var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import { renderDynamicComponent } from '../render';
function TabPanel(props) {
    var children = props.children, value = props.value, index = props.index, other = __rest(props, ["children", "value", "index"]);
    return value === index && React.createElement(React.Fragment, null, children);
}
var DynamicTabs = /** @class */ (function (_super) {
    __extends(DynamicTabs, _super);
    function DynamicTabs(props, ctx) {
        var _this = _super.call(this, props, ctx) || this;
        _this.state = {
            selectedTabIndex: 0
        };
        return _this;
    }
    DynamicTabs.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(AppBar, { position: "static" },
                React.createElement(Tabs, { value: this.state.selectedTabIndex, onChange: function (event, newValue) { return _this.setState({ selectedTabIndex: newValue }); } }, this.props.control.children.map(function (tab, index) { return React.createElement(Tab, { key: index, label: tab.label }); }))),
            this.props.control.children
                .map(function (tab, index) { return React.createElement(TabPanel, { key: index, value: _this.state.selectedTabIndex, index: index }, tab.children.map(function (child, index) { return renderDynamicComponent(index, child, _this.props.dataState); })); }));
    };
    return DynamicTabs;
}(React.Component));
export default DynamicTabs;
//# sourceMappingURL=Tabs.js.map